<template>
<div class="ion-padding view-whats-app-wrapper">
  <div v-if="isPreviewReady && !templateLoading" class="chat">
    <div class="chat-container">
      <p class="ion-no-margin ion-padding-bottom sctn-labels">Message</p>
      <div class="conversation">
        <div class="conversation-container">
          <div v-if="campaignMessage !== ''" class="message--cont received marginBottom">
            <div class="customPadding">
              <p class="previewTitle ion-no-margin">{{ campaignMessage }}</p>
            </div>
          </div>
          <div class="message--cont received">
            <div class="customPadding">
            <template v-if="body.header">
              <div class="img--cont" v-if="body.header.format === 'IMAGE'">
                <img height="50" v-if="(body.header?.url || (body.header?.example && (origin === 'templates' || (origin === 'broadcast' && (isViewOnlyMode))))) && finalUrlType == 'static'" :src="body.header?.url || ((origin === 'templates' || (origin === 'broadcast' && (isViewOnlyMode || isDuplicateBroadcast))) ? body.header?.example : null)" class="preview_media" />
                <img height="50" v-else src="@/resources/images/upload-image-placeholder-dotted.svg" />
              </div>
              <div class="img--cont" v-if="body.header.format === 'VIDEO'">
                <video height="50" v-if="(body.header?.url || (body.header?.example && (origin === 'templates' || (origin === 'broadcast' && (isViewOnlyMode))))) && finalUrlType == 'static'" :src="body.header?.url || ((origin === 'templates' || (origin === 'broadcast' && (isViewOnlyMode || isDuplicateBroadcast))) ? body.header?.example : null)" controls class="preview_media" />
                <img height="50" v-else src="@/resources/images/whatsapp_preview_placeholder.svg">
              </div>
              <div class="img--cont" v-if="body.header.format === 'DOCUMENT'">
                <span v-if="(body.header?.url || (body.header?.example && (origin === 'templates' || (origin === 'broadcast' && (isViewOnlyMode))))) && finalUrlType == 'static'" class="sub-title ion-no-margin overflow-text" style="display: inline;" >
                  {{ body.header?.url ? body.header?.url.split('/').pop() : ((origin === 'templates' || (origin === 'broadcast' && (isViewOnlyMode))) ? body.header?.example.split('/').pop() : 'File.pdf') }}
                </span>
                <img height="50" v-else src="@/resources/images/document_placeholder.svg" alt="">
              </div>
              <p class="ion-no-margin headerText" v-if="body.header.format === 'TEXT'" :dir="isRtlLanguage ? 'rtl' : 'ltr'">
                {{ body.header?.text }}
              </p>
            </template>
            <div v-if="templateType === 'LTO'">
              <div class="ltoContainer">
                <VIcon name="tag-line"></VIcon>
                <div>
                  <p class="subtitle ion-no-margin paddingBottom header">
                    {{ lto_offerTitleText || 'LTO Title' }}
                  </p>
                  <p v-if="formattedExpirationMessage" class="subtitle ion-no-margin paddingBottom header" > {{ formattedExpirationMessage }} </p>
                  <p class="subtitle ion-no-margin subtext">Code: {{ body?.coupon_code || 'TEST100' }} </p>
                </div>
              </div>
            </div>
            <div v-if="body.body?.text || body.body?.html">
              <p v-if="body.body?.text" v-html="formattedText(body.body?.text)" :dir="isRtlLanguage ? 'rtl' : 'ltr'" class="previewTitle ion-no-margin"></p>
              <p v-if="body.body?.html" v-html="body.body?.html"  :dir="isRtlLanguage ? 'rtl' : 'ltr'" class="previewTitle ion-no-margin"></p>
            </div>
            <div class="footerText custMargin" style="padding-left: 5px;">
              <p class="time ion-no-margin">{{ body.footer?.text }}</p>
            </div>
            <div class="metadata">
              <p class="time ion-no-margin">{{ currentTime }}</p>
            </div>
            </div>
            <div v-if="templateType !== 'Carousel'">
              <div class="btn--cont" v-if="body.allButtons && body.allButtons.length || allButtons && allButtons.length">
                <div class="btn--forWhatsapp" v-for="(thisButton, bIndex) in displayedButtons" :key="bIndex">
                  <VIcon v-if="thisButton.action !== undefined || thisButton.type !== undefined" :name="getIcon(thisButton)" class="whatsappIcons"></VIcon>
                  <span>{{ thisButton.text }}</span>
                </div>
                <div class="btn--forWhatsapp" v-if="showSeeAllOptions">
                  <VIcon name="bullet-list-line" class="whatsappIcons"></VIcon>
                  <span>See All Options</span>
                </div>
              </div>
            </div>
          </div>
          <!-- whastsapp Quick Reply buttons -->
          <div v-if="quickReplyButtons && quickReplyButtons.length" class="qr-chips-cont">
            <div v-for="(btn, idx) in quickReplyButtons" :key="'qr-chip-' + idx" class="qr-chip-btn">
              {{ btn.title || btn.text }}
            </div>
          </div>
        </div>
        <div v-if="templateType === 'Carousel'">
          <div class="carousel-container ion-no-padding">
            <button v-if="carouselMessage?.CAROUSEL?.cards.length > 1" class="navigate-preview backward nav-btn" @click="slidePrev()" :disabled="!isEnablePrevButton">
              <VIcon name="chevron-left-line"></VIcon>
            </button>

            <button v-if="carouselMessage?.CAROUSEL?.cards.length > 1" class="navigate-preview forward nav-btn" @click="slideNext()" :disabled="!isEnableNextButton">
              <VIcon name="chevron-right-line"></VIcon>
            </button>
            <div
              ref="carouselTrack"
              class="carousel-track"
              role="group"
              tabindex="0"
              aria-label="Carousel cards"
              @scroll="onTrackScroll"
            >
              <div v-for="(carousel, index) in carouselMessage?.CAROUSEL?.cards" :key="index" class="carousel-track-slide">
                <div class="singleCarouselCard">
                  <div class="container">
                    <div class="img-block cursorPointer">
                      <div>
                        <div v-if="carousel?.components[0].format == 'IMAGE'">
                          <img v-if="(carousel?.components[0].overridden_url || carousel?.components[0].image_url) !== ''" :src="sanitizeHardLinkUrl(carousel?.components[0].overridden_url || carousel?.components[0].image_url)" width="200" class="carouselImage" /> 
                          <img v-else height="50" src="@/resources/images/upload-image-placeholder-dotted.svg">   
                        </div>
                        <div v-else>
                          <video v-if="(carousel?.components[0].overridden_url || carousel?.components[0].image_url) !== ''" :src="sanitizeHardLinkUrl(carousel?.components[0].overridden_url || carousel?.components[0].image_url)" controls preload="metadata" width="200" class="carouselImage" />  
                          <img v-else height="50" src="@/resources/images/whatsapp_preview_placeholder.svg">         
                        </div>
                      </div>
                    </div>
                    <div class="carousel-title">
                      <p class="ion-no-margin title" v-html="formattedText(carousel.components[1].text)"></p>
                    </div>
                    <div class="carousel--bttn">
                      <div v-for="button in carousel.components[2].buttons" :key="button.id" class="btn--forWhatsapp">
                        <VIcon :name="getIcon(button)" class="whatsappIcons"></VIcon>
                        <span>{{ button.text }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else-if="isViewOnlyMode || isDuplicateBroadcast" class="spinnerContainer">
    <div class="marginBottom">
      <VProgressRing connotation="cta" :size="-3" />
    </div>
    <p class="sub-title ion-no-margin">Just a moment — loading your preview.</p>
  </div>
  <!-- FallBack Message -->
  <div v-if="fallBackMessage !== '' && checkFallBackMessageEnabled" class="custBorderTop">
    <p class="ion-no-margin ion-padding-bottom sctn-labels">Fallback message</p>
    <div class="fallBackContainer" v-html="formattedFallBackMessage"> </div>
  </div>
</div>
</template>

<script>
import marketingOptinSubscribed from '@/resources/images/marketing-optin-subscribed-button.svg';
import marketingOptinUnsubscribed from '@/resources/images/marketing-optin-unsubscribed-button.svg';

const sendOutline = 'message-sent-line';
const cameraOutline = 'camera-line';
const happyOutline = 'emoji-line';
const callOutline = 'call-line';
const attachOutline = 'attachment-line';
const ellipsisVerticalOutline = 'more-vertical-line';
const arrowBackOutline = 'arrow-left-line';
const openOutline = 'open-line';
const copyOutline = 'copy-2-line';
const filmOutline = 'media-player-line';
const arrowUndoOutline = 'undo-solid';
const chevronBackOutline = 'chevron-left-line';
import { sanitizeHardLinkUrl } from '@/helpers/message.helpers';
import { enableDragScroll, getScrollNavigationState, rafThrottle, scrollTrackByOneSlide, scrollTrackToSlide } from '@/helpers/carousel.helpers';

export default {
  mixins: [],
  data() {
    return {
      arrowBackOutline,
      ellipsisVerticalOutline,
      attachOutline,
      callOutline,
      happyOutline,
      cameraOutline,
      sendOutline,
      openOutline,
      copyOutline,
      filmOutline,
      arrowUndoOutline,
      isEnablePrevButton: false,
      isEnableNextButton: true,
      currentTime: '',
      onTrackScroll: null,
      teardownDragScroll: null
    }
  },
  props: {
    body: {
      type: Object,
      default: () => { return {}; }
    },
    allButtons: {
      type: Array,
      default: () => { return []; }
    },
    quickReplyButtons: {
      type: Array,
      default: () => { return []; }
    },
    templateType: {
      type: String,
      default: "generic"
    },
    carouselMessage: {
      type: Object,
      default: () => { return {}; }
    },
    fallBackMessage: {
      type: String,
      default: ""
    },
    lto_offerTitleText: {
      type: String,
      default: "LTO Title"
    },
    checkFallBackMessageEnabled: {
      type: Boolean,
      default: false
    },
    campaignMessage: {
      type: String,
      default: ""
    },
    origin: {
      type: String,
      default: ""
    },
    isViewOnlyMode: {
      type: Boolean,
      default: false
    },
    isDuplicateBroadcast: {
      type: Boolean,
      default: false
    },
    expiration_date_time: {
      type: String,
      default: ""
    },
    templateLoading: {
      type: Boolean,
      default: false
    },
    selectedLanguage: {
      type: String,
      default: "en"
    },
    finalUrlType: {
      type: String,
      default: "static"
    }
  },
  created() {
    this.onTrackScroll = rafThrottle(this.slidNavigationHandler);
  },
  mounted() {
    this.updateTime();
    // auto-refresh time every minute
    setInterval(this.updateTime, 60000);
    window.addEventListener('resize', this.onTrackScroll);
    this.$nextTick(() => {
      this.slidNavigationHandler();
      this.teardownDragScroll = enableDragScroll(this.$refs.carouselTrack);
    });
  },
  updated() {
    // Re-evaluate nav state once the carousel track renders or its cards change.
    this.onTrackScroll();
    // The track only mounts once the preview is ready and the template is a carousel.
    this.teardownDragScroll = enableDragScroll(this.$refs.carouselTrack);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.onTrackScroll);
    this.onTrackScroll?.cancel();
    this.teardownDragScroll?.();
  },
  computed: {
    formattedFallBackMessage() {
      return this.fallBackMessage.replace(/\n/g, '<br>');
    },
    displayedButtons() {
      const allButtons = this.body.allButtons || this.allButtons || [];
      return allButtons.slice(0, 2);
    },
    showSeeAllOptions() {
      const allButtons = this.body.allButtons || this.allButtons || [];
      return allButtons.length > 2;
    },
    formattedExpirationMessage() { // formatting expiry time for LTO
      if (!this.expiration_date_time) return '';
      const date = new Date(this.expiration_date_time);
      const options = { month: 'long', day: 'numeric' };
      const formattedDate = date.toLocaleDateString('en-US', options);
      return `Ends on ${formattedDate}`;
    },
    isPreviewReady() {
      const isLoading = this.templateLoading;
      const headerReady = this.body?.header?.format === 'TEXT'
        ? !!this.body.header?.text
        : ['IMAGE', 'VIDEO', 'DOCUMENT'].includes(this.body?.header?.format) &&
          (
            !!this.body?.header?.url ||
            ((this.origin === 'templates' || (this.origin === 'broadcast' && (this.isViewOnlyMode))) && !!this.body?.header?.example)
          );

      const bodyReady = this.body?.body?.text || this.body?.body?.html;
      const footerReady = !!this.body?.footer?.text;
      const couponReady = !!this.body?.coupon_code;
      const ltoReady = this.templateType === 'LTO';
      const buttonsReady = (this.body?.allButtons && this.body.allButtons.length > 0) || (this.allButtons && this.allButtons.length > 0) || (this.quickReplyButtons && this.quickReplyButtons.length > 0);
      const carouselReady = this.templateType === 'Carousel' && this.carouselMessage?.CAROUSEL?.cards?.length > 0;

      return !isLoading && (headerReady || bodyReady || footerReady || couponReady || ltoReady || buttonsReady || carouselReady);
    },
     isRtlLanguage() {
      const rtlLanguages = ['ar', 'he', 'fa', 'ur'];
      return rtlLanguages.includes(this.selectedLanguage.toLowerCase());
    },
  },
  methods: {
    sanitizeHardLinkUrl,
    getIcon(thisButton) {
			if (thisButton.action === 'phone' || thisButton.sub_type == 'phone_number') {
				return callOutline;
			} else if (thisButton.action === 'website' || thisButton.sub_type == 'url' || thisButton.type == 'url' || thisButton.type == 'URL') {
				return openOutline;
			} else if (thisButton.action === 'COPY_CODE' || thisButton.sub_type == 'copy_code') {
				return copyOutline;
			} else if(thisButton.payload == 'compliance_opt_in') {
        return marketingOptinSubscribed;
      } else if(thisButton.payload == 'compliance_opt_out') {
        return marketingOptinUnsubscribed;
      } else if (thisButton.type === 'QUICK_REPLY' || thisButton.sub_type == 'quick_reply') {
				return arrowUndoOutline;
			} else {
				return '';
			}
		},
    slidNavigationHandler() {
      const { isEnablePrevButton, isEnableNextButton } = getScrollNavigationState(this.$refs.carouselTrack);
      this.isEnablePrevButton = isEnablePrevButton;
      this.isEnableNextButton = isEnableNextButton;
    },
    slideNext() {
      scrollTrackByOneSlide(this.$refs.carouselTrack, 1);
    },
    slidePrev() {
      scrollTrackByOneSlide(this.$refs.carouselTrack, -1);
    },
    navigateToSlide(index) {
      scrollTrackToSlide(this.$refs.carouselTrack, index);
    },
    formattedText(text) {
      // First handle dynamic variables
      let formattedText = text.replace(/<([^>]+)>/g, (match, p1) => {
        return `<span class="dynamic-variable-span">&lt;${p1}&gt;</span>`;
      });
      
      // Then convert line breaks to <br> tags for proper display
      formattedText = formattedText.replace(/\n/g, '<br>');
      
      return formattedText;
    },
    updateTime() {
      const now = new Date();
      const hours = now.getHours();
      const minutes = now.getMinutes();
      const formattedTime = `${hours % 12 || 12}:${minutes < 10 ? '0' + minutes : minutes} ${hours >= 12 ? 'pm' : 'am'}`;
      this.currentTime = formattedTime;
    }
  }
}
</script>

<style scoped>
.view-whats-app-wrapper {
  padding: 0px;
}
.chat {
  height: calc(100% - 69px);
  position: relative;
  top: -6px;
}

.chat-container {
  height: 100%;
}

.conversation {
  height: calc(100% - 12px);
  position: relative;
  background: #efe7dd url(https://cloud.githubusercontent.com/assets/398893/15136779/4e765036-1639-11e6-9201-67e728e86f39.jpg) repeat;
  z-index: 0;
}

.conversation .conversation-container {
  height: calc(100% - 48px);
  overflow-x: hidden;
  padding: 20px;
}

.conversation .message--cont {
  color: #000;
  clear: both;
  line-height: 14px;
  font-size: 13px;
  padding: 8px;
  width: 100%;
  border: none;
  padding: 0;
  text-align: left;
  position: relative;
  margin: 8px 0;
  max-width: 85%;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-word;
  hyphens: auto;
  z-index: -1;
}
.customPadding{
  padding: 4px;
}

.conversation .received {
  background: #fff;
  border-radius: 0px 5px 5px 5px;
  float: left;
}

.conversation-container .message--cont {
  color: #000;
  clear: both;
  line-height: 14px;
  font-size: 13px;
  width: 60%;
  margin: 0px;
  border: none;
  text-align: left;
  position: relative;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-word;
  hyphens: auto;
  z-index: auto;
  position: relative;
}
.metadata {
  float: right;
}
.metadata .time {
  color: var(--gray-04);
  font-size: 12px;
  padding-bottom: 5px;
}

.conversation-container .btn--cont {
  width: 100%;
  float: left;
  border-top: 1px solid #EDEDED;
  text-align: center;
}

.conversation-container .btn--cont .btn--forWhatsapp {
  background: #fff;
  font-size: 13px;
  padding-bottom: 10px;
  color: #049CE5;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  border: 1px solid #EDEDED;
  border-top: none;
}
.conversation-container .btn--cont .btn--forWhatsapp:first-child{
  border-top: none;
}

.message--cont.received:after {
  border-width: 0px 10px 10px 0;
  border-color: transparent #fff transparent transparent;
  top: 0;
  left: -10px;
}

.message--cont:after {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  border-style: solid;
}

.message--cont .img--cont {
  text-align: center;
  background: #cccfd4;
  padding: 20px 10px;
}
.custMargin{
  margin: 0px 0px 10px 0px;
}
.whatsappIcons{
  margin-right: 5px;
  color: #049CE5;
}
.carousel_container{
  background: #CCCFD4;
  width: 100%;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.carouselCard{
  background: #CCCFD4;
  width: 20%;
  height: 100px;
}
.filmIcon{
  width: 100px;
  height: 60px;
  color: white;
}

.flexBox{
  display: flex;
  gap: 5px;
}
.singleCarouselCard {
  display: flex;
  flex-direction: column;
  width: auto;
  min-width: fit-content;
  flex-shrink: 0;
}
.singleCarouselCard::-webkit-scrollbar {
  display: none;
}
.singleCarouselCard .container{
  min-width: 220px;
  max-width: 260px;
  background: var(--white );
  margin: 0 auto;
  margin-right: 15px;
  flex-shrink: 0;
}
.img-block{
	padding: 15px 10px;
  background: #EDEDED;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 140px;
  border: 1px solid #EDEDED;
}
.carousel-title{
	border: 1px solid #EDEDED;
  border-top: none;
  border-bottom: none;
  padding: 10px;
  font-size: 14px;
  color: var(--black);
}
.singleCarouselCard .carousel--bttn{
  border: 1px solid #EDEDED;
}
.singleCarouselCard .btn--forWhatsapp{
  padding: 10px;
  font-size: 14px;
  color: var(--black);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 0px;
}
.singleCarouselCard .btn--forWhatsapp:first-child{
  border-bottom: 1px solid #EDEDED;
}
.carouselImage{
	border-radius: 5px;
  object-fit: cover;
  width: 100%;
  height: 120px;
}
.fallBackContainer{
  background: #EDEDED;
  padding: 10px;
  border-radius: 5px;
  color: #242424;
  line-height: 30px;
}
.custBorderTop{
  border-top: 1px solid #EDEDED;
  padding-top: 20px;
  margin-top: 20px;
}
.previewTitle{
  font-size: 14px;
  color: #242424;
  font-weight: 400;
  margin: 10px 5px;
  line-height: 18px;
  white-space: pre-line;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-word;
  hyphens: auto;
}
.ltoContainer{
  display: flex;
  align-items: center;
  gap: 10px;
  background: #EDEDED;
  border-radius: 5px;
  padding: 10px;
}
.ltoContainer .subtext{
  color: var(--gray-04);
  font-size: 12px;
}
.ltoContainer .header{
  font-size: 13px;
  color: #242424;
}
.paddingBottom{
  padding-bottom: 2px;
}
.subtitle{
  font-size: 13px;
  color: #242424;
  font-weight: 400;
}
.headerText{
  font-size: 16px;
  color: #242424;
  font-weight: 700;
  padding: 5px 0px 0px 5px;
}
.carousel-container {
  height: 100%;
  width: 100%;
  position: relative;
  padding: 0px 20px 20px 20px;
  overflow-x: hidden;
}
.carousel-track {
  height: 100%;
  max-width: 400px;
  margin: 0 auto 0 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  /* default inter-slide spacing */
  gap: 15px;
  overflow-x: auto;
  overflow-y: hidden;
  scroll-snap-type: x mandatory;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.carousel-track::-webkit-scrollbar {
  display: none;
}
.carousel-track-slide {
  height: 100%;
  width: auto;
  flex: 0 0 auto;
  scroll-snap-align: start;
}
/* responsive inter-slide spacing */
@media only screen and (min-width: 320px) {
  .carousel-track { gap: 10px; }
}
@media only screen and (min-width: 480px) {
  .carousel-track { gap: 12px; }
}
@media only screen and (min-width: 768px) {
  .carousel-track { gap: 15px; }
}
@media only screen and (min-width: 1024px) {
  .carousel-track { gap: 20px; }
}
.navigate-preview {
  position: absolute;
  top: 0;
  height: 100%;
  display: flex;
  align-items: center;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 4px;
  z-index: 5;
}
.navigate-preview:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}
.navigate-preview.backward {
  left: -12px;
}
.navigate-preview.forward {
  right: -12px;
}
.marginBottom {
  margin-bottom: 20px !important;
}
.qr-chips-cont {
  width: 60%;
  float: left;
  clear: both;
  display: flex;
  flex-direction: column;
  gap: 1px;
  margin-top: 2px;
}
.qr-chip-btn {
  background: #fff;
  border: 1px solid #EDEDED;
  border-radius: 8px;
  padding: 10px;
  font-size: 13px;
  font-weight: 600;
  color: #1B8755;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.footerText{
  float: left;
  white-space: normal; 
  word-break: break-word;
  width: 100%;
}
.footerText p {
  font-size: 12px;
  color: var(--gray-04);
}
.preview_media{
  width: 100%;
  height: 100%;
  border-radius: 5px;
  pointer-events: auto;
  z-index: 10;
  position: relative;
}
.spinnerContainer{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
@media only screen and (max-width: 760px) {
  .prevMobile {
    display: block;
  }
  .prevDesktop {
    display: none;
  }  
  .singleCarouselCard .container {
    min-width: 180px;
    max-width: 200px;
    margin-right: 12px;
  }
  
  .carousel-container {
    padding: 0px 15px 20px 15px;
  }
}

@media only screen and (max-width: 480px) {
  .singleCarouselCard .container {
    min-width: 160px;
    max-width: 180px;
    margin-right: 10px;
  }
  
  .carousel-container {
    padding: 0px 10px 20px 10px;
  }
  
  .navigate-preview.backward {
    left: -8px;
  }
  
  .navigate-preview.forward {
    right: -8px;
  }
}

@media only screen and (min-width: 481px) and (max-width: 1024px) {
  .singleCarouselCard .container {
    margin-right: 20px;
  }
}
</style>